export default __webpack_public_path__ + "static/media/brand-black.137017bd.svg";